import { render, staticRenderFns } from "./module-goods.vue?vue&type=template&id=225ce3c2&scoped=true"
import script from "./module-goods.vue?vue&type=script&lang=js"
export * from "./module-goods.vue?vue&type=script&lang=js"
import style0 from "./module-goods.vue?vue&type=style&index=0&id=225ce3c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ce3c2",
  null
  
)

export default component.exports